/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Choose_Audio_Track_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Choose audio track" |
*
* @param {Player_Choose_Audio_Track_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_choose_audio_track_aria_label = /** @type {((inputs?: Player_Choose_Audio_Track_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Choose_Audio_Track_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisir la piste audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiospur auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli la traccia audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите звуковую дорожку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elegir pista de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择音轨")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオトラックを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो ट्रैक चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a faixa de áudio")
	return /** @type {LocalizedString} */ ("Choose audio track")
});